<template>
  <b-card class="payment-detail-card">
    <b-table
      class="payment-detail-table"
      small
      responsive
      show-empty
      :fields="fields"
      :items="items"
      :busy="isBusy"
      hover
      size="sm"
      bordered
      head-variant="dark"
    >
      <template #cell()="data">
        <span class="table-cell">{{ data.value }}</span>
      </template>
      <template #table-busy>
        <div class="text-center text-primary my-4">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
          <strong class="ml-2">Cargando detalles...</strong>
        </div>
      </template>

      <template #cell(index)="data">
        <span class="table-cell">{{ data.index + 1 }}</span>
      </template>

      <template #cell(description)="data">
        <span class="table-cell description-cell">
          {{ data.value }}
        </span>
      </template>

      <template #cell(amount)="data">
        <span class="table-cell amount-cell">
          {{ formatCurrency(data.value) }}
        </span>
      </template>

      <template #custom-foot>
        <tr class="total-row">
          <td
            colspan="4"
            class="text-right"
          >
            <strong>Total:</strong>
          </td>
          <td class="text-right total-amount">
            <strong>{{ formatCurrency(total) }}</strong>
          </td>
        </tr>
      </template>
    </b-table>
  </b-card>
</template>

<script>
/* eslint-disable */
import { BCard, BSpinner, BTable } from 'bootstrap-vue'

export default {
    name: 'AccountSettingPaymentDetail',
    components: {
        BCard,
        BTable,
        BSpinner,
    },
    props: {
        idpayment: {
            type: [String, Number],
            required: true,
            default: null,
        },
    },
    data() {
        return {
            isBusy: false,
            items: [],
            fields: [
                { key: 'index', label: 'No.' },
                { key: 'establishment_number', label: 'Serie' },
                { key: 'invoice_number', label: 'Factura' },
                { key: 'description', label: 'Concepto' },
                { key: 'amount', label: 'Monto', class: 'text-right' },
            ],
        }
    },
    computed: {
        total() {
            return this.items.reduce(
                (total, item) => total + (parseFloat(item.amount) || 0),
                0
            )
        },
    },
    created() {
        // Inicialización del componente
        this.loadDetails()
    },
    methods: {
        loadDetails() {
            if (!this.idpayment) return

            this.isBusy = true
            this.$http
                .get(`/payment-detail/${this.idpayment}`)
                .then((response) => {
                    this.isBusy = false
                    this.items = response.data.data || []
                })
                .catch((error) => {
                    this.isBusy = false
                    this.items = []
                })
        },

        formatCurrency(value) {
            return new Intl.NumberFormat('es-ES', {
                style: 'currency',
                currency: 'USD',
            }).format(value)
        },
    },
}
</script>

<style scoped>
.payment-detail-modal {
    background: rgba(255, 255, 255, 0.95);
}

.payment-detail-modal .modal-content {
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.payment-detail-modal .modal-header {
    background: linear-gradient(45deg, #2c3e50, #34495e);
    color: white;
    border-radius: 10px 10px 0 0;
    padding: 1rem 1.5rem;
}

.payment-detail-modal .modal-header .modal-title {
    font-weight: 600;
    font-size: 1.2rem;
}

.payment-detail-card {
    border: none;
    box-shadow: none;
    background: transparent;
}

.payment-detail-table {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.payment-detail-table :deep(thead) {
    background: linear-gradient(45deg, #2c3e50, #34495e);
}

.payment-detail-table :deep(thead th) {
    border: none;
    color: white;
    font-weight: 600;
    padding: 0.75rem;
    text-transform: uppercase;
    font-size: 0.8rem;
    letter-spacing: 0.5px;
}

.payment-detail-table :deep(tbody td) {
    padding: 0.75rem;
    vertical-align: middle;
    border-color: #f0f0f0;
}

.payment-detail-table :deep(tbody tr:hover) {
    background-color: rgba(44, 62, 80, 0.05);
    transition: all 0.3s ease;
}

.table-cell {
    font-size: 0.9rem;
    color: #2c3e50;
}

.description-cell {
    font-weight: 500;
}

.amount-cell {
    font-weight: 600;
    color: #2c3e50;
}

.total-row {
    background: linear-gradient(45deg, #f8f9fa, #ffffff);
    font-size: 0.95rem;
}

.total-row td {
    padding: 1rem !important;
    border-top: 2px solid #2c3e50 !important;
}

.total-amount {
    color: #2c3e50;
    font-size: 1.1rem;
    font-weight: 700;
}

:deep(.table-bordered) {
    border: 1px solid #e9ecef;
}

:deep(.table-bordered td),
:deep(.table-bordered th) {
    border: 1px solid #e9ecef;
}
</style>
